<template>
  <div class="bexs-autosuggest">
    <input
      id="SubjectCategory"
      ref="SubjectCategory"
      autocomplete="off"
      :class="{ 'has-error': hasError }"
      type="text"
      class="form-control"
      :placeholder="$t('login.fields.typeToSearch')"
      @change="fieldUpdated('')"
    />

    <button
      v-show="subjectSelected"
      type="button"
      class="close"
      @click="fieldUpdated('')"
    >
      <i class="icon-close"></i>
      <span class="sr-only">Clear</span>
    </button>

    <typeahead
      :value="subjectSelected"
      :open-on-empty="true"
      :async-function="fetch"
      target="#SubjectCategory"
      item-key="description"
    >
      <template slot="item" slot-scope="props">
        <li
          v-for="(item, index) in props.items"
          :key="item.id"
          :class="{ active: props.activeIndex === index }"
        >
          <div
            class="autocomplete-template"
            :title="`${item.name} | ${item.description}`"
            @click="fieldUpdated(item)"
          >
            <div class="text with-thumb">
              <dl class="text-left">
                <dt>{{ item.name }}</dt>

                <dd>{{ item.description }}</dd>
              </dl>
            </div>
          </div>
        </li>
      </template>
    </typeahead>
  </div>
</template>

<script>
  // OBSOLETE: Remove this component to new version without ticket
  import services from '@/services'

  import Issue from './emission-field'

  export default {
    name: 'SubjectCategoryField',
    props: {
      id: {
        type: String,
        required: true
      },
      value: {
        default: '',
        required: false
      },
      hasError: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        fieldValue: undefined
      }
    },
    computed: {
      subjectSelected() {
        return (
          this.fieldValue ||
          (this.value.fieldId ? this.value.fieldValue : this.value)
        )
      }
    },
    methods: {
      fetch(query, done) {
        services.main.searchSubjects(query).then(s => done(s))
      },
      fieldUpdated(item) {
        this.fieldValue = item

        this.$emit('input', Issue.createField(this.id, this.fieldValue, false))
      }
    }
  }
</script>

<style scoped>
  .dropdown {
    width: 100%;
    position: absolute;
    margin-top: 5px;
  }
</style>
